import htmlToDom from '../../../../helpers/htmlToDom';

export default ({ time, isAvailable }) =>
	htmlToDom(`
		<li class="modal__time-item" data-rm-time="${time}">
			<label class="modal__time-label" for="time-${time}">
				<input 
					class="modal__time-input" 
					${isAvailable ? 'disabled' : ''}
					id="time-${time}" 
					name="time" 
					type="radio" 
					value="${time}"
				>
				<div class="modal__time-input--fake">${time}</div>
			</label>
		</li>
	`);
